<template>

  <div :class="['layout',aside?'show':'']">
    <ul class="aside">
      <li @click="goIndex()" v-if="!isMobile"><img src="../../assets/img/nav1.png" alt=""></li>
      <!-- <li @click="playMusic()" :class="music?'on':''"><img :src="music?`${$url}img/nav2_on.png`:`${$url}img/nav2.png`" alt=""></li> -->
      <li @click="Scene()"><img :src="scene?`${$url}img/scene_on.png`:`${$url}img/scene.png`" alt=""></li>
      <li @click="Antiques()" v-if="!isMobile"><img :src="antique?`${$url}img/nav4_on.png`:`${$url}img/nav4.png`" alt=""></li>
    </ul>
    <!-- <audio id="bgmusic" class="bgmusic" :src="`${$url}bg.mp3`" style="display:none"></audio> -->
  </div>
  
  
</template>


<script>
import browser from '@/utils/browser.js'

export default {
  components:{
  },
  data(){
    return {

      aside:false,
      arrow:false,
      isMobile: browser.mobile,
      music:false,
      scene:false,
      antique:false,
    }
  },
  computed:{
  },
  watch: {
    '$store.state.aside'() {
      this.aside = this.$store.state.aside//监听$store.state.aside，如果发生变化，aside也变化
    }
  },
  methods:{
    goIndex() {
      if(this.position == true) {
         this.Position();
      }     
      if(this.antique == true) {
        this.Antiques();
       /*  document.getElementById("detail").innerHTML="";
        document.getElementById("detail").classList.remove("layout") */
        
      }
      if(this.music == true) {
        this.playMusic();
      }
      this.$router.push('/');
    },
   playMusic() {
     this.music = ! this.music ;
     var bgmusic = document.getElementById("bgmusic");
     if(this.music) {
       bgmusic.play();
     }else {
       bgmusic.pause();
     }
   },
   Scene() {
     this.$router.push('/scene')
   },
   Antiques() {
     this.antique = ! this.antique;
     this.$showAntiques();
     var iframe = document.getElementById("iframeContainer");
     iframe.contentWindow.postMessage ('旋转');
     
     
   },
   showAside() {
     var _this = this;
     if(this.aside == true) {
        this.aside = false;
        setTimeout(function(){
          _this.arrow = false;
        },
        1000)
       
     }else {
        this.arrow = true;
       this.aside = true;
     }
     
   }
  },
  created() {
   
  },
  mounted() {
    var _this = this;
     setTimeout(function() {
      _this.aside = true;
      _this.arrow = true;
    },0)
  }
}
</script>

<style lang="less" scoped>
  .aside {
    position:absolute;
    right:1.5vw;
    width:4vw;
    bottom:20%;
    li {
      width:4vw;
      height:3.64vw;
      margin-bottom:1.3vw;
    }
  }
  @media screen and (max-width:600px) {
    .aside {
      position:absolute;
      right:10px;
      width:15vw;
      bottom:auto;
      top:20px;
      li {
        width:15vw;
        margin-bottom:1.3vw;
      }
    }
  }
</style>

